module.exports = __webpack_public_path__ + "static/media/painting.165bf99c.jpeg";